import { render, staticRenderFns } from "./checkDetailLegacy.vue?vue&type=template&id=4c707e16&scoped=true"
import script from "./checkDetailLegacy.vue?vue&type=script&lang=js"
export * from "./checkDetailLegacy.vue?vue&type=script&lang=js"
import style0 from "./checkDetailLegacy.vue?vue&type=style&index=0&id=4c707e16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c707e16",
  null
  
)

export default component.exports